import React, { Component } from 'react';
import $ from "jquery";
import config from "../../config";
import { ApiClient } from "../../libs/apiClient";
import {
    GroupCodeModal,
    CardCodeReferenceCreationModal,
    CardTypeModal,
    CurrencyModal,
    TerritoriesModal,
    ContactPersonsPartnerModal,
    AddressesPartnerModal,
    CountryModal,
    StatesModal,
    ImpuestoPartnerModal,
    PayMethodModal,
    BankAccountModal,
    SearchPartnerRefSys
} from "../index";
import EmployeeSalesPartnerModal from "../EmployeeSalesPartnerModal";
import GroupNumModal from "../GroupNumModal";
import PriceListPartnerModal from "../PriceListPartnerModal";
import UserFieldsPartnerModal from "../UserFieldsPartnerModal";
import { Addresses, ContactPersons } from "../NewOrder";
import moment from 'moment';
import AccountBalancePartner from '../AccountBalancePartner';
import AccountListPartnerModal from '../AccountListPartnerModal';
import { CURRENCY, FORMAT_NUMBER, ZIPCODE, RFC_FORMAT } from '../../libs/utils/Const';
import '../../css/fields.css';
import { event } from 'jquery';
let apiClient = ApiClient.getInstance();
const disableField = true;

class ReferralSystemPerson extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            groupCodes: [],
            cardTypes: [],
            currencies: [],
            employees: [],
            groupNums: [],
            prices: [],
            territories: [],
            contactPersons: [],
            addresses: [],
            countries: [],
            states: [],
            taxes: [],
            payMethods: [],
            addressesIndexSelected: null,
            countryIndexSelected: null,
            AccountBalan: [],
            CardCodeBalance: [],
            AccountBalanceData: {},
            cardCodeReferenceList: [],
            checkConso: false,
            accounts: [],
            accountMayorId: '',
            MajorAccounts: [],
            userConfigFieldsBP: JSON.parse(localStorage.getItem('userConfigFielsBP')) || null,
            partners: [],
            pageTotal: 0,
            enableSearchPartner: false

        };

        this.newModelCopy = '';
    }

    componentDidMount() {
        this._handelBack();
        // this.checkConfigFields('userConfigFielsBP', false);
        this.GetBankAccounts();
    }

    GetBankAccounts = async () => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        let responseApi = await apiClient.getCuentaMayor();
        enableSpinner(false);


        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        this.setState({ MajorAccounts: responseApi.data || [] })
    };

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    }

    closeModal = () => {
        this.checkConfigFields('userConfigFielsBP', false);
        this.forceUpdate()
        $('#BussinesPartner').modal('hide');
    }

    openAction = () => {
        let document = this;
        const { newOrderModel } = this.props;
        $('#BussinesPartner').on('hide.bs.modal', function () {
        });
    };

    ValidateLicTradNum = async () => {
        const { partnerModel } = this.props;
        let text = document.querySelector(`#grupo__rfcB .form__input-error`);
        let require = document.querySelector(`#grupo__rfcB .form__input-void`);
        if (partnerModel.LicTradNum && partnerModel.LicTradNum != '') {
            if (!RFC_FORMAT.test(partnerModel.LicTradNum)) {
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
                return
            } else {
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        } else {
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }
        return true
    }

    ValidateZipCodeShip = async () => {
        const { partnerModel, } = this.props;
        const { DeliveriesAddress, deliveriesAddressEditIndex } = partnerModel;
        let deliveriesAddress = deliveriesAddressEditIndex != null ? DeliveriesAddress[deliveriesAddressEditIndex] : {};
        let text = document.querySelector(`#grupo__BDA6 .form__input-error`);
        let require = document.querySelector(`#grupo__BDA6 .form__input-void`);

        if (!deliveriesAddress.ZipCode == "") {
            if (!ZIPCODE.test(deliveriesAddress.ZipCode)) {
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
                return
            } else {
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        } else {
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }

        return true
    }

    ValidateZipCodeBill = async () => {
        const { partnerModel, } = this.props;
        const { InvoicesAddress, invoicesAddressEditIndex } = partnerModel;
        let invoicesAddress = invoicesAddressEditIndex != null ? InvoicesAddress[invoicesAddressEditIndex] : {};
        let text = document.querySelector(`#grupo__BPIA6 .form__input-error`);
        let require = document.querySelector(`#grupo__BPIA6 .form__input-void`);

        if (!invoicesAddress.ZipCode == "") {
            if (!ZIPCODE.test(invoicesAddress.ZipCode)) {
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
                return
            } else {
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        } else {
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }

        return true
    }

    ValidateAll = async (action) => {
        const { partnerModel } = this.props;
        // this.ValidateZipCodeBill()
        // this.ValidateLicTradNum()
        // if (await this.ValidateZipCodeBill() === true && await this.ValidateLicTradNum() === true) {
        //     action()
        // }
        if (await !this.ValidateBusinessPartnerModel(partnerModel)) return
        action()
    }

    sendModel = async () => {
        const { sendModel, partnerModel } = this.props;
        if (await !this.ValidateBusinessPartnerModel(partnerModel)) return
        sendModel(partnerModel);
    };

    ValidateBusinessPartnerModel = partnerModel => {
        const { showAlert, auxView } = this.props
        let passParterModel = true;

        if (partnerModel.FatherType === '') {
            showAlert({ type: 'warning', message: 'En el apartado de FINANZAS y dentro en apartado GENERAL seleccione "Consolidacion de pagos" ó "Consolidacion de entregas" por favor', timeOut: 9999 });
            passParterModel = false
        }
        if (partnerModel.VatStatus === '') {
            showAlert({ type: 'warning', message: 'En el apartado de FINANZAS y dentro en apartado IMPUESTO seleccione "Obligatorio" ó "Extranjeros" por favor', timeOut: 9999 });
            passParterModel = false
        }
        if (partnerModel.GroupCodeName === '') {
            showAlert({ type: 'warning', message: 'En el apartado de cabecera seleccione el grupo al que pertenece el socio por favor', timeOut: 9999 });
            passParterModel = false
        }
        if (partnerModel.CardTypeName === '') {
            showAlert({ type: 'warning', message: 'En el apartado de cabecera seleccione el tipo de socio por favor', timeOut: 9999 });
            passParterModel = false
        }
        if (partnerModel.GroupNumName === '') {
            showAlert({ type: 'warning', message: 'En el apartado de Condición de Pago seleccione la forma de pago del socio', timeOut: 9999 });
            passParterModel = false
        }
        if (partnerModel.PriceListNum === '') {
            showAlert({ type: 'warning', message: 'En el apartado de Condición de Pago seleccione la lista de precios del socio', timeOut: 9999 });
            passParterModel = false
        }
        if (partnerModel.LicTradNum === '') {
            showAlert({ type: 'warning', message: 'En el apartado de cabecera complete el RUT ', timeOut: 9999 });
            passParterModel = false
        }
        if (auxView === 'referredPartner' && partnerModel.U_FMB_RELATED_AMBASSADOR === '') {
            showAlert({ type: 'warning', message: 'Debe de seleccionar un socio embajador para crear un socio referido', timeOut: 9999 });
            passParterModel = false
        }
        if (auxView === 'ambassador' && partnerModel.U_FMB_EMAIL_AMBASSADOR === '') {
            showAlert({ type: 'warning', message: 'Debe de insertar un correo electrónico valido en la parte de cabecera', timeOut: 9999 });
            passParterModel = false
        }
        return passParterModel;
    }

    acceptEditMode = () => {
        const { acceptEditMode, partnerModel } = this.props;

        acceptEditMode(partnerModel);
    };

    cancelEditMode = () => {
        const { partnerModel, cancelEditMode } = this.props;
        cancelEditMode();
        this.setState({
            editMode: false,
        });
        this.checkConfigFields('userConfigFielsBP', false);
        this.forceUpdate()
    };

    editMode = () => {
        this.setState({
            editMode: !this.state.editMode,
        });
        // console.log('job this.state.editMode', this.state.editMode)
        // if (this.state.editMode == true){
        // console.log('job',"entro")
        this.checkConfigFields('userConfigFielsBP', true);
        this.forceUpdate()
        // }
    };

    deleteBank = (deleteBank) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === deleteBank.AbsEntry) {

                partnerModel.BankAccounts.splice(index, 1);
            }

        }

        this.refreshModel(partnerModel);
    }

    changeAccountBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {

            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.Account = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    changeControlKeyBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.ControlKey = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    changeBranchBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.Branch = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    changeIBANBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.IBAN = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    changeSwiftNumBank = (register, event) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {
            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === register.AbsEntry) {

                BankAccountModel.SwiftNum = event.nativeEvent.target.value;
            }
        }
        this.refreshModel(partnerModel);

    }

    selectBankDefault = (newBankModel) => {
        const { partnerModel } = this.props;

        for (let index = 0; index < partnerModel.BankAccounts.length; index++) {

            const BankAccountModel = partnerModel.BankAccounts[index];

            if (BankAccountModel.AbsEntry === newBankModel.AbsEntry) {
                partnerModel.DefaultBankCode = BankAccountModel.BankCode || ''; //015
                partnerModel.BankCountr = BankAccountModel.Country; //Mexico
                partnerModel.BankCode = BankAccountModel.BankName; //BBVA
                partnerModel.DflAccount = BankAccountModel.Account;
                partnerModel.DflSwift = BankAccountModel.SwiftNum;
                partnerModel.DflBranch = BankAccountModel.Branch;
                partnerModel.BankCtlKey = BankAccountModel.ControlKey;
                partnerModel.DflIBAN = BankAccountModel.IBAN;
            }
        }

        this.refreshModel(partnerModel);

        $('#bankAccountModal').modal('hide');
    }

    changeBusinessPartnerCardCode = event => {
        const { partnerModel } = this.props;
        partnerModel.CardCode = event.nativeEvent.target.value;
        this.refreshModel(partnerModel);
    };

    changeBusinessPartnerCardName = event => {
        const { partnerModel } = this.props;
        partnerModel.CardName = event.nativeEvent.target.value;
        this.refreshModel(partnerModel);
    };

    changeBusinessPartnerLicTradNum = event => {
        const { partnerModel } = this.props;
        partnerModel.LicTradNum = event.nativeEvent.target.value;
        this.refreshModel(partnerModel);
    };

    changeBusinessPartnerBonoTruper = (value) => {
        const { partnerModel } = this.props;
        partnerModel.U_PTruper = value;
        this.refreshModel(partnerModel);
    };

    changeBusinessPartnerProntoPago = (value) => {
        const { partnerModel } = this.props;
        value += "";

        if (value.trim() === ".") value = "0.";
        if (!isNaN(value.replace(/,/g, '')) && !value.includes('-')) partnerModel.U_Ppago = value.trim();
        this.refreshModel(partnerModel);
    };

    validateBusinessPartnerProntoPago = () => {
        const { partnerModel } = this.props;
        if (!partnerModel.U_Ppago) partnerModel.U_Ppago = 0;
        partnerModel.U_Ppago += "";
        partnerModel.U_Ppago = FORMAT_NUMBER.new((partnerModel.U_Ppago).replace(/,/g, ''))
        this.refreshModel(partnerModel);
    };

    changeBusinessPartnerPhone1 = event => {
        const { partnerModel } = this.props;
        if (isNaN(event.nativeEvent.target.value) == false && (event.nativeEvent.target.value).length <= 10) {
            partnerModel.Phone1 = event.nativeEvent.target.value;
            this.refreshModel(partnerModel);
        }
    };

    changeBusinessPartnerPhone2 = event => {
        const { partnerModel } = this.props;
        if (isNaN(event.nativeEvent.target.value) == false && (event.nativeEvent.target.value).length <= 10) {
            partnerModel.Phone2 = event.nativeEvent.target.value;
            this.refreshModel(partnerModel);
        }

    };

    changeCorreo = event => {
        const { partnerModel } = this.props;
        partnerModel.E_mail = event.nativeEvent.target.value;
        this.refreshModel(partnerModel);
    };

    changeCreditLine = event => {
        const { partnerModel } = this.props;
        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                partnerModel.CreditLine = event.nativeEvent.target.value;
            }
            this.refreshModel(partnerModel);
        }
    };

    changeIDContacto = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Name = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeFirstName = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].FirstName = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeTitle = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Title = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeMiddleName = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].MiddleName = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changePosition = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Position = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeLastName = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].LastName = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeTel1 = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Tel1 = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeTel2 = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Tel2 = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeCellolar = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Cellolar = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeFax = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Fax = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeE_mail = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].E_MailL = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeNotes1 = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Notes1 = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeNotes2 = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Notes2 = event.nativeEvent.target.value;
        }

        this.refreshModel(partnerModel);
    };

    changeActiveContact = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.ContactPersons[contactEditIndex].Active = event.target.checked ? 'Y' : 'N';
        }

        this.refreshModel(partnerModel);
    };

    changeContactDefault = event => {
        const { partnerModel, partnerModel: { contactEditIndex } } = this.props;

        if (contactEditIndex != null) {
            partnerModel.CntctPrsn = partnerModel.ContactPersons[contactEditIndex].Name;
        }

        this.refreshModel(partnerModel);
    };


    validateCreditLineNull = () => {
        const { partnerModel } = this.props;
        const value = partnerModel.CreditLine;
        const debitValue = partnerModel.DebtLine;

        if (!value?.length) { partnerModel.CreditLine = 0; }
        else if (Number(value) > Number(debitValue)) { partnerModel.DebtLine = FORMAT_NUMBER.new(partnerModel.CreditLine); }

        partnerModel.CreditLine = FORMAT_NUMBER.new(partnerModel.CreditLine);
        this.refreshModel(partnerModel);
    };

    changeDebitLine = event => {
        const { partnerModel } = this.props;
        if (!isNaN(event.nativeEvent.target.value)) {
            if (event.nativeEvent.data != ' ') {
                partnerModel.DebtLine = event.nativeEvent.target.value;
            }
            this.refreshModel(partnerModel);
        }
    };

    changeRefDetails = event => {
        const { partnerModel } = this.props;
        if (event.nativeEvent.data != ' ') {
            partnerModel.RefDetails = event.nativeEvent.target.value;
        }
        this.refreshModel(partnerModel);
    };

    validateDebitLineNull = () => {
        const { partnerModel } = this.props;
        const value = partnerModel.CreditLine;
        const debitValue = partnerModel.DebtLine;

        if (!value?.length) { partnerModel.DebtLine = 0; }
        else if (Number(value) > Number(debitValue)) { partnerModel.DebtLine = partnerModel.CreditLine; }

        partnerModel.DebtLine = FORMAT_NUMBER.new(partnerModel.DebtLine);
        this.refreshModel(partnerModel);
    };

    refreshModel = partnerModel => {
        const { refreshModel } = this.props;
        refreshModel(partnerModel);
    };

    ChangeDpmClear = (value) => {
        const { partnerModel } = this.props;
        partnerModel.DownPaymentClearAct = value;
        this.refreshModel(partnerModel);
    }

    ChangeDpmIntAct = (value) => {
        const { partnerModel } = this.props;
        partnerModel.DownPaymentInterimAccount = value;
        this.refreshModel(partnerModel);
    }

    changeAddress = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;
        if (type === 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Address = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Address = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }
        }

        this.refreshModel(partnerModel);
    };

    changeStreet = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Street = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Street = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }
        }

        this.refreshModel(partnerModel);
    };

    changeBlock = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex }, showAlert } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Block = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Block = event.nativeEvent.target.value;
            } else {
                showAlert({ type: 'warning', message: 'Seleccione agregar dirección' });
            }
        }

        this.refreshModel(partnerModel);
    };

    changeCity = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].City = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].City = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    };

    changeZipCode = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].ZipCode = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].ZipCode = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    };

    changeCounty = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].County = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].County = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    };

    openState = async type => {
        const { showAlert, partnerModel, enableSpinner, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        enableSpinner(true);
        let groupCodeResponse = await apiClient.getState();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        let country = '';
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                country = partnerModel.InvoicesAddress[invoicesAddressEditIndex].Country;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                country = partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Country;
            }
        }


        let states = [];

        groupCodeResponse.data.map(state => {
            //console.log("dfsdfsdf", country, state.Country);
            if (state.Country == country) {
                states.push(state)
            }
        });


        if (states.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar con el País seleccionado' });
            return;
        }

        this.setState({
            states: states,
            countryIndexSelected: type,
        });

        $('#statesModal').modal('show');
    };

    selectState = action => {
        const { states, countryIndexSelected } = this.state;
        let state = states[action.index];
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (countryIndexSelected == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].State = state.Code;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].State = state.Code;
            }
        }
        this.refreshModel(partnerModel);
        $('#statesModal').modal('hide');
    };

    openCountry = async type => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getCountry();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            countries: groupCodeResponse.data,
            countryIndexSelected: type,
        });

        $('#countryModal').modal('show');
    };

    selectCountry = action => {
        const { countries, countryIndexSelected } = this.state;
        let country = countries[action.index];
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (countryIndexSelected === 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Country = country.Code;
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].State = '';
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Country = country.Code;
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].State = '';
            }
        }

        this.refreshModel(partnerModel);
        $('#countryModal').modal('hide');
    };

    changePartnerActive = value => {
        const { partnerModel } = this.props;
        partnerModel.validFor = value;
        this.refreshModel(partnerModel);
    };

    openPayMethod = async type => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.payMethod();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            payMethods: groupCodeResponse.data,
        });

        $('#payMethodsModal').modal('show');
    };

    selectPayMethod = action => {
        let { partnerModel } = this.props;
        const { payMethods } = this.state;
        let payMethod = payMethods[action.index];
        let newMethod = [];

        newMethod.push({ PymCode: payMethod.PayMethCod });
        partnerModel.PymCode = payMethod.PayMethCod;
        partnerModel.PymCodeName = payMethod.Descript;

        partnerModel.PayMethodCodes = newMethod;
        this.refreshModel(partnerModel);
        $('#payMethodsModal').modal('hide');
    };

    openTaxes = async type => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getTaxesList();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            taxes: groupCodeResponse.data,
            countryIndexSelected: type,
        });

        $('#taxesPartnerModal').modal('show');
    };

    selectTaxes = action => {
        const { taxes, countryIndexSelected } = this.state;
        let taxe = taxes[action.index];
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (countryIndexSelected == 'invoices') {
            if (invoicesAddressEditIndex != null) {
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].TaxCode = taxe.Code;
            }
        }
        partnerModel.TaxCode = taxe.Code || '';
        partnerModel.TaxName = taxe.Name || '';

        this.refreshModel(partnerModel);
        $('#taxesPartnerModal').modal('hide');
    };

    changeBuilding = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].Building = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Building = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    };

    changeTaxOffice = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].TaxOffice = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].TaxOffice = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    };

    changeStreetNo = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].StreetNo = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].StreetNo = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    };

    changeGlblLocNum = (event, type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;
        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.InvoicesAddress[invoicesAddressEditIndex].GlblLocNum = event.nativeEvent.target.value;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].GlblLocNum = event.nativeEvent.target.value;
            }
        }

        this.refreshModel(partnerModel);
    };

    changeAddressDefault = (type) => {
        const { partnerModel, partnerModel: { invoicesAddressEditIndex, deliveriesAddressEditIndex } } = this.props;

        if (type == 'invoices') {
            if (invoicesAddressEditIndex != null) {
                partnerModel.BillToDef = partnerModel.InvoicesAddress[invoicesAddressEditIndex].Address;
            }

        } else {
            if (deliveriesAddressEditIndex != null) {
                partnerModel.ShipToDef = partnerModel.DeliveriesAddress[deliveriesAddressEditIndex].Address;
            }
        }

        this.refreshModel(partnerModel);
    };

    openCardType = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        this.setState({
            cardTypes: [
                { code: 'C', name: 'Cliente' },
                { code: 'S', name: 'Proveedor' },
                { code: 'L', name: 'Lead' },
            ],
        });

        setTimeout(() => {
            $('#cardTypeModal').modal('show');
        }, 100)

    };

    getBusinessPartnerCode = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        if (partnerModel.CardType === '') {
            showAlert({ type: 'warning', message: 'Selecciona el tipo de socio de negocios para encontrar coincidencias' });
            return;
        }

        let filter = {
            cardCodeReference: partnerModel.CardCode || '',
            cardType: partnerModel.CardType || ''
        }

        enableSpinner(true);
        let businesPartnerResponse = await apiClient.getPartnerList(filter);
        enableSpinner(false);


        if (!Array.isArray(businesPartnerResponse.data.partners)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (businesPartnerResponse.data.partners.length === 0) {
            showAlert({ type: 'info', message: 'No existen coincidencias con su código de socio' });
            return;
        }

        this.setState({
            cardCodeReferenceList: businesPartnerResponse.data.partners,
        });

        $('#cardCodeReferenceCreationModal').modal('show');
    };

    selectCardType = async action => {
        const { cardTypes } = this.state;
        const { partnerModel } = this.props;
        let cardType = cardTypes[action.index];

        partnerModel.CardType = cardType.code;
        partnerModel.CardTypeName = cardType.name;
        $('#cardTypeModal').modal('hide');
        this.refreshModel(partnerModel);
    };

    openGroupCode = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getGroupCode();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            groupCodes: groupCodeResponse.data,
        });

        $('#groupCodeModal').modal('show');
    };

    openGroupNum = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupNumResponse = await apiClient.getGroupNum();
        enableSpinner(false);

        if (!Array.isArray(groupNumResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupNumResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            groupNums: groupNumResponse.data,
        });

        $('#groupNumModal').modal('show');
    };

    selectGroupNum = action => {
        const { groupNums } = this.state;
        const { partnerModel } = this.props;
        let groupNum = groupNums[action.index];

        partnerModel.GroupNum = groupNum.GroupNum;
        partnerModel.GroupNumName = groupNum.PymntGroup;

        partnerModel.ChangeGroupNum = true;

        $('#groupNumModal').modal('hide');
        this.refreshModel(partnerModel);
    };

    selectGroupCode = action => {
        const { groupCodes } = this.state;
        const { partnerModel } = this.props;
        let groupCode = groupCodes[action.index];

        partnerModel.GroupCode = groupCode.GroupCode;
        partnerModel.GroupCodeName = groupCode.GroupName;

        $('#groupCodeModal').modal('hide');
        this.refreshModel(partnerModel);
    };

    openCuentaMayor = async (cuenta) => {
        const { showAlert, enableSpinner, view } = this.props;

        enableSpinner(true);
        let response = await apiClient.getCuentaMayorPartner();
        enableSpinner(false);

        if (!Array.isArray(response.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (response.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            accounts: response.data,
            accountMayorId: cuenta,
        });

        $('#AccountListPartnerModal').modal('show');
    };

    selectAccountList = action => {
        const { accounts, accountMayorId } = this.state;
        const { partnerModel, refreshModel } = this.props;
        let account = accounts[action.index];

        if (accountMayorId === 1) {
            partnerModel.DebPayAcct = account.FormatCode || '';
            partnerModel.DebPayAcctName = account.AcctName || '';
        }

        refreshModel(partnerModel);
        $('#AccountListPartnerModal').modal('hide');
        setTimeout(() => {
            this.setState({
                account: [],
            });
        }, 100);
    };

    openCurrency = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let currencyResponse = await apiClient.getCurrenciesPartner();
        enableSpinner(false);

        if (!Array.isArray(currencyResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (currencyResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            currencies: currencyResponse.data,
        });

        $('#currencyModal').modal('show');
    };

    selectCurrency = action => {
        const { currencies } = this.state;
        const { partnerModel } = this.props;
        let currency = currencies[action.index];

        partnerModel.Currency = currency.CurrCode;
        partnerModel.CurrencyName = currency.CurrName;
        $('#currencyModal').modal('hide');
        this.refreshModel(partnerModel);
    };

    openEmployee = async () => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        const getEmployeeResponse = await apiClient.getEmployeeList();
        enableSpinner(false);

        if (!Array.isArray(getEmployeeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getEmployeeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            employees: getEmployeeResponse.data,
        });
        $('#employeeSalesPartnerModal').modal('show');
    };

    openTerritory = async () => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let getTerritoriesResponse = await apiClient.getTerritories();
        enableSpinner(false);

        if (!Array.isArray(getTerritoriesResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getTerritoriesResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            territories: getTerritoriesResponse.data,
        });
        $('#territoriesModal').modal('show');
    };

    selectTerritories = action => {
        const { territories } = this.state;
        const { partnerModel } = this.props;
        let territory = territories[action.index];

        partnerModel.Territory = territory.territryID || '';
        partnerModel.TerritoryName = territory.descript || '';
        this.refreshModel(partnerModel);
        $('#territoriesModal').modal('hide');
        setTimeout(() => {
            this.setState({
                territories: [],
            });
        }, 100);
    };

    selectEmployee = action => {
        const { employees } = this.state;
        const { partnerModel } = this.props;
        let employee = employees[action.index];

        partnerModel.SlpCode = employee.SlpCode || '';
        partnerModel.SlpName = employee.SlpName || '';

        this.refreshModel(partnerModel);
        $('#employeeSalesPartnerModal').modal('hide');
        setTimeout(() => {
            this.setState({
                employees: [],
            });
        }, 100);
    };

    addContactPersons = async () => {
        const { showAlert, partnerModel } = this.props;
        let newContact = new ContactPersons();

        partnerModel.ContactPersons.push(newContact);
        partnerModel.contactEditIndex = partnerModel.ContactPersons.length - 1;

        this.refreshModel(partnerModel);
    };

    deleteContactPersons = async (name) => {
        const { showAlert, partnerModel } = this.props;
        let newContact = new ContactPersons();

        let contactArray = [];
        partnerModel.ContactPersons.map(contact => {
            if (contact.Name != name) {
                contactArray.push(contact)
            }
        });

        partnerModel.ContactPersons = contactArray;
        partnerModel.contactEditIndex = null;

        if (partnerModel.CntctPrsn == name) {
            partnerModel.CntctPrsn = '';
        }

        this.refreshModel(partnerModel);
    };

    openContactPersons = async () => {
        const { showAlert, partnerModel } = this.props;

        if (partnerModel.ContactPersons.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            contactPersons: partnerModel.ContactPersons,
        });

        setTimeout(() => {
            $('#contactPersonsPartnerModal').modal('show');
        }, 100)

    };

    selectContactPersons = action => {
        const { partnerModel } = this.props;
        let contact = partnerModel.ContactPersons[action.index];

        partnerModel.contactEditIndex = action.index;

        this.refreshModel(partnerModel);
        $('#contactPersonsPartnerModal').modal('hide');
    };


    addAddresses = async type => {
        const { showAlert, partnerModel } = this.props;
        let newAddress = new Addresses();
        showAlert({ type: 'info', message: 'Ingrese la dirección' });
        if (type == 'invoices') {
            newAddress.TypeOfAddress = 'B';
            partnerModel.InvoicesAddress.push(newAddress);
            partnerModel.invoicesAddressEditIndex = partnerModel.InvoicesAddress.length - 1;
        } else {
            newAddress.TypeOfAddress = 'S';
            partnerModel.DeliveriesAddress.push(newAddress);
            partnerModel.deliveriesAddressEditIndex = partnerModel.DeliveriesAddress.length - 1;
        }
        this.refreshModel(partnerModel);
    };

    deleteInvoicesAddress = async (Address) => {
        const { showAlert, partnerModel } = this.props;
        let newAddress = new Addresses();

        let addressArray = [];
        partnerModel.InvoicesAddresss.map(address => {
            if (address.Address != Address) {
                addressArray.push(newAddress)
            }
        });

        partnerModel.InvoicesAddresss = addressArray;
        partnerModel.invoicesAddressEditIndex = null;

        if (partnerModel.BillToDef == Address) {
            partnerModel.BillToDef = '';
        }

        this.refreshModel(partnerModel);
    };

    openAddresses = async type => {
        const { showAlert, partnerModel } = this.props;

        let address = [];
        if (type == 'invoices') {

            if (partnerModel.InvoicesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
            address = partnerModel.InvoicesAddress;
        } else {
            if (partnerModel.DeliveriesAddress.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }

            address = partnerModel.DeliveriesAddress;
        }

        this.setState({
            addresses: address,
            addressesIndexSelected: type
        });

        setTimeout(() => {
            $('#addressPartnerModal').modal('show');
        }, 100)

    };
    openBankAccount = async type => {
        const { showAlert, partnerModel } = this.props;

        setTimeout(() => {
            $('#bankAccountModal').modal('show');
        }, 100)

    };

    selectAddresses = (action) => {
        const { partnerModel } = this.props;
        const { addressesIndexSelected } = this.state;

        if (addressesIndexSelected == 'invoices') {
            partnerModel.invoicesAddressEditIndex = action.index;
        } else {
            partnerModel.deliveriesAddressEditIndex = action.index;
        }


        this.refreshModel(partnerModel);
        $('#addressPartnerModal').modal('hide');
    };

    deleteAddresses = (action) => {
        const { partnerModel } = this.props;
        const { addressesIndexSelected } = this.state;

        if (addressesIndexSelected == 'invoices') {
            partnerModel.InvoicesAddress.splice(action.index, 1);
            partnerModel.invoicesAddressEditIndex = partnerModel.InvoicesAddress.length > 0 ? 0 : null;
        } else {
            partnerModel.DeliveriesAddress.splice(action.index, 1);
            partnerModel.deliveriesAddressEditIndex = partnerModel.DeliveriesAddress.length > 0 ? 0 : null;
        }


        this.refreshModel(partnerModel);
        $('#addressPartnerModal').modal('hide');
    };

    openListNum = async () => {
        const { showAlert, partnerModel, enableSpinner } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getPriceList();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            prices: groupCodeResponse.data,
        });

        $('#priceListPartnerModal').modal('show');
    };

    selectPriceList = action => {
        const { prices } = this.state;
        const { partnerModel } = this.props;
        let price = prices[action.index];
        partnerModel.PriceListNum = price.ListNum;
        partnerModel.PriceListNumName = price.ListName;
        $('#priceListPartnerModal').modal('hide');
        this.refreshModel(partnerModel);
    };

    renderEditButton = () => {
        const { action, writeAccess } = this.props;
        const { editMode } = this.state;
        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || null;

        if ((action === 2 && !editMode) && writeAccess) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
        if (!user || user.FMB_Role !== 'admin1') {
            return (
                <div>
                </div>
            )
        }
    };

    openAccountBalance = async (info = null) => {
        const { partnerModel, enableSpinner, showAlert } = this.props;


        var date = new Date();
        let cardCode = partnerModel.CardCode || '';
        var firstDay = moment(new Date(date.getFullYear(), 0, 1)).format('YYYY-MM-DD');
        var lastDay = moment(new Date(date.getFullYear(), 11, 31)).format('YYYY-MM-DD');
        let data;

        if (info) {
            data = {
                CardCode: info.CardCode,
                FirstDay: info.FirstDay,
                LastDay: info.LastDay,
                DocDate: info.DocDate,
                Visualize: info.Visualize,
                VisualizeNum: info.VisualizeNum,
                OnlyUnreconciled: info.OnlyUnreconciled
            }

        } else {
            data = {
                CardCode: cardCode,
                FirstDay: firstDay,
                LastDay: lastDay,
                DocDate: true,
                Visualize: true,
                VisualizeNum: 50,
                OnlyUnreconciled: true
            }
        }


        let getAccountResponse;
        enableSpinner(true);
        getAccountResponse = await apiClient.getAccountBalance(data);
        enableSpinner(false);

        if (!Array.isArray(getAccountResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }
        if (getAccountResponse.data === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        this.setState({
            CardCodeBalance: getAccountResponse.data[0],
            AccountBalan: getAccountResponse.data[1],
            AccountBalanceData: data
        });
        if (!info) {
            $('#accountBalancePartnerModal').modal('show');
        }
    }

    elementDisabled(id, action) {
        let state = document.getElementById(id);
        if (state.disabled == false) {
            action()
        }
    }

    changeRefSysAmbassadorEmail = event => {
        const { partnerModel } = this.props;
        partnerModel.U_FMB_EMAIL_AMBASSADOR = event.nativeEvent.target.value;
        this.refreshModel(partnerModel);
    };

    changeRefSysAmbassadorPassword = event => {
        const { partnerModel } = this.props;
        partnerModel.U_FMB_PASS_AMBASSADOR = event.nativeEvent.target.value;
        this.refreshModel(partnerModel);
    };


    ValidateExistLicTradNum = async () => {
        const { partnerModel, enableSpinner, showAlert } = this.props;

        const data = {
            LicTradNum: partnerModel?.LicTradNum
        }
        enableSpinner(true);
        const responseApi = await apiClient.validateExistReferredPartner(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return
        }
        showAlert({ type: 'info', message: `${responseApi.message}` });
    }

    renderBussinesHeader = () => {
        const { partnerModel, action, view } = this.props;
        const { editMode } = this.state;

        let titleDNotesBal = '';
        let titleOrdersBal = '';

        if (partnerModel.CardType === 'C') {
            titleDNotesBal = 'Entregas:';
            titleOrdersBal = 'P. clientes:';
        }

        if (partnerModel.CardType === 'S') {
            titleDNotesBal = 'P. E. Mercancías:';
            titleOrdersBal = 'Pedidos:';
        }

        if (partnerModel.CardType === 'L') {
            titleDNotesBal = 'P. E. Mercancías:';
            titleOrdersBal = 'P. clientes:';
        }
        return (
            <div className="row">
                {/*PRIMER COLUMNA SOCIOS DE NEGOCIO*/}
                <div className="col-12 col-lg-6">
                    {/*RFC*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> RUT </span>
                        </div>
                        <input
                            id="txtRFC"
                            className="form-control"
                            disabled={(action === 2 && !editMode)}
                            value={partnerModel?.LicTradNum || ""}
                            onChange={this.changeBusinessPartnerLicTradNum}
                            onBlur={this.ValidateLicTradNum} />
                        <div className="input-group-prepend">
                            <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.ValidateExistLicTradNum}>
                                <i className="fa fa-search" />
                            </button>
                        </div>
                    </div>

                    <div className="form-group formulario__grupo" id="grupo__rfcB">
                        <p className="form__input-error" style={{ marginTop: "-14px" }}> Formato valido: (XAXX010101000) </p>
                        <p className="form__input-void" style={{ marginTop: "-14px" }}> RUT no puede ir vació </p>
                    </div>

                    {/*NOMBRE DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Nombre </span>
                        </div>
                        <input
                            id="txtCardName"
                            className="form-control"
                            disabled={(action === 2 && !editMode)}
                            onChange={this.changeBusinessPartnerCardName}
                            value={partnerModel?.CardName || ""} />
                    </div>

                    {/*CÓDIGO DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Código </span>
                        </div>
                        <input
                            id="txtCardCode"
                            className="form-control"
                            disabled={action === 2}
                            onChange={this.changeBusinessPartnerCardCode}
                            value={partnerModel?.CardCode || ""} />

                        {((action === 2) && partnerModel.CardCode !== '') &&
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" onClick={() => this.openAccountBalance()}>
                                    <i className="fas fa-info-circle" />
                                </button>
                            </div>
                        }
                    </div>

                    {this.props.auxView === 'ambassador' &&
                        <>
                            {/* Correo */}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <label className="input-group-text font-weight-bold" htmlFor="txtEmail"> Correo </label>
                                </div>
                                <input
                                    id="txtEmail"
                                    className="form-control"
                                    disabled={(action === 2 && !editMode)}
                                    value={partnerModel.U_FMB_EMAIL_AMBASSADOR ? partnerModel.U_FMB_EMAIL_AMBASSADOR : ""}
                                    onChange={(event) => this.changeRefSysAmbassadorEmail(event)}

                                />
                            </div>

                            {/* PASSWORD */}
                            {/* <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <label className="input-group-text font-weight-bold" htmlFor="txtEmail"> Contraseña </label>
                                </div>
                                <input
                                    id="txtEmail"
                                    className="form-control"
                                    disabled={(action === 2 && !editMode)}
                                    value={partnerModel.U_FMB_PASS_AMBASSADOR ? partnerModel.U_FMB_PASS_AMBASSADOR : ""}
                                    onChange={(event) => this.changeRefSysAmbassadorPassword(event)}
                                />
                            </div> */}

                        </>
                    }


                </div>

                {/*SEGUNDA COLUMNA SOCIOS DE NEGOCIO*/}
                <div className="col-12 col-lg-6">

                    {/*Typo DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Tipo </span>
                        </div>
                        <input
                            id="txtType"
                            className="form-control"
                            disabled
                            value={partnerModel?.CardTypeName || ""} />
                        {(action === 1 || (action === 2 && editMode)) &&
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" disabled={disableField} onClick={this.openCardType}>
                                    <i className="fa fa-list" />
                                </button>
                            </div>
                        }
                    </div>

                    {/*GRUPO DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Grupo </span>
                        </div>
                        <input
                            className="form-control"
                            id="txtGroupCode"
                            disabled
                            value={partnerModel?.GroupCodeName || ""} />
                        {(action === 1 || (action === 2 && editMode)) &&
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" disabled={disableField} onClick={this.openGroupCode}>
                                    <i className="fa fa-list" />
                                </button>
                            </div>
                        }
                    </div>

                    {/*MONEDA DE SOCIO DE NEGOCIOS*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Moneda </span>
                        </div>
                        <input
                            id="txtCurrency"
                            className="form-control"
                            disabled
                            value={partnerModel?.CurrencyName || ""} />
                        {(action === 1 || (action === 2 && editMode)) &&
                            <div className="input-group-prepend">
                                <button type="button" className="btn btn-outline-warning rounded-right" disabled={disableField} onClick={this.openCurrency} >
                                    <i className="fa fa-list" />
                                </button>
                            </div>
                        }
                    </div>

                    {/* Saldo de Cuenta */}
                    {(action === 2 && (partnerModel.CardType == 'C' || partnerModel.CardType == 'S')) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <label className="input-group-text font-weight-bold"> Saldo de cuenta </label>
                            </div>
                            <label className="form-control text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(partnerModel.Balance)}</label>
                        </div>
                    }

                    {/* Entregas - Etrada de mercancia */}
                    {(action === 2 && (partnerModel.CardType == 'C' || partnerModel.CardType == 'S')) &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <label className="input-group-text font-weight-bold"> {titleDNotesBal} </label>
                            </div>
                            <label className="form-control text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(partnerModel.DNotesBal)}</label>
                        </div>
                    }

                    {/* Pedidos */}
                    {action === 2 &&
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <label className="input-group-text font-weight-bold"> {titleOrdersBal} </label>
                            </div>
                            <label className="form-control text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(partnerModel.OrdersBal)}</label>
                        </div>
                    }
                </div>
            </div>
        )
    }

    onChangeValueConsolidacion = (event) => {
        const { partnerModel, refreshModel } = this.props;
        partnerModel.VatStatus = event.nativeEvent.target.value;
        refreshModel(partnerModel);
    }

    onChangeValueConsolidacion2 = (event) => {
        const { partnerModel, refreshModel } = this.props;
        partnerModel.FatherType = event.nativeEvent.target.value;
        refreshModel(partnerModel);

    }

    onChangeRetencion = () => {
        const { partnerModel, refreshModel } = this.props;
        partnerModel.WTLiable = !partnerModel.WTLiable;
        refreshModel(partnerModel);
    }

    hideOrDisableFields(field, editMode) {
        let element = document.getElementById(field.id);
        // const { editMode} = this.state;
        if (element !== null) {
            if (field.show === false) {
                element.classList.add('hidden');
            } else {
                element.classList.remove('hidden');
            }
            // console.log('job editModeeditModeeditMode', editMode)
            if (editMode === false || field.edit === false) {
                $("#" + field.id).find("input, button, submit, textarea, select").attr("disabled", "disabled");
                $("#" + field.id).find("a").addClass("disablehyper").click(function (e) { e.preventDefault(); });
                $("#" + field.id).find("input, button, submit, textarea, select").addClass("disable");
            } else {
                $("#" + field.id).find("input, button, submit, textarea, select").removeAttr("disabled");
                $("#" + field.id).find("a").removeClass("disablehyper").unbind("click");
                $("#" + field.id).find("input, button, submit, textarea, select").removeClass("disable");
            }
        }
    }

    checkConfigFields(userConfig, editMode = false) {
        let config = JSON.parse(localStorage.getItem(userConfig)) || null;
        for (const key in config) {
            this.hideOrDisableFields(config[key], editMode)
        }
    }


    OpenModalPartner = async () => {
        await this.setState({
            enableSearchPartner: true
        });
        $('#searchPartnerRefSys').modal('show');

    };

    // SelectPartner = async action => {
    //     const { partnerModel } = this.props;
    //     const { partners } = this.state;

    //     const partner = partners[action.index];
    //     partnerModel.U_FMB_RELATED_AMBASSADOR = partner?.CardCode ?? '';
    //     this.refreshModel(partnerModel)

    //     $('#partnerCreate').modal('hide');
    //     $('#newCustomer').modal('show');
    // }

    renderBussinesBody = () => {
        const { partnerModel, action } = this.props;
        const { editMode, MajorAccounts, userConfigFieldsBP } = this.state;
        const { ContactPersons, DeliveriesAddress, InvoicesAddress, contactEditIndex, deliveriesAddressEditIndex, invoicesAddressEditIndex } = partnerModel;
        let contactPerson = contactEditIndex != null ? ContactPersons[contactEditIndex] : {};
        let deliveriesAddress = deliveriesAddressEditIndex != null ? DeliveriesAddress[deliveriesAddressEditIndex] : {};
        let invoicesAddress = invoicesAddressEditIndex != null ? InvoicesAddress[invoicesAddressEditIndex] : {};

        return (
            <div>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-General"
                            data-toggle="tab"
                            href="#DatosMaestrosGeneral"
                            role="datosgeneral"
                            aria-controls="DatosMaestrosGeneral"
                            aria-selected="true">
                            General
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-CondPago"
                            data-toggle="tab"
                            href="#DatosMaestrosCondPago"
                            role="datoscondpago"
                            aria-controls="DatosMaestrosCondPago"
                            aria-selected="false">
                            Condición Pago
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Direcciones"
                            data-toggle="tab"
                            href="#DatosMaestrosDirecciones"
                            role="datosdirecciones"
                            aria-controls="DatosMaestrosDirecciones"
                            aria-selected="false">
                            Dirección
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-ContactPerson"
                            data-toggle="tab"
                            href="#DatosMaestrosContactPerson"
                            role="datoscontactperson"
                            aria-controls="DatosMaestrosContactPerson"
                            aria-selected="false">
                            Persona Contacto
                        </a>


                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-EjecPago"
                            data-toggle="tab"
                            href="#DatosMaestrosEjecPago"
                            role="datosejecpago"
                            aria-controls="DatosMaestrosEjecPago"
                            aria-selected="false">
                            Ejecución Pago
                        </a> */}

                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Finanzas"
                            data-toggle="tab"
                            href="#DatosMaestrosFinanzas"
                            role="datosfinanzas"
                            aria-controls="DatosMaestrosFinanzas"
                            aria-selected="false">
                            Finanzas
                        </a>
                        {/*<a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Propiedades"
                            data-toggle="tab"
                            href="#DatosMaestrosPropiedades"
                            role="datospropiedades"
                            aria-controls="DatosMaestrosPropiedades"
                            aria-selected="false">
                            Propiedades
                        </a>*/}
                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Comentarios"
                            data-toggle="tab"
                            href="#DatosMaestrosComentarios"
                            role="datoscomentarios"
                            aria-controls="DatosMaestrosComentarios"
                            aria-selected="false">
                            Comentarios
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Anexos"
                            data-toggle="tab"
                            href="#DatosMaestrosAnexos"
                            role="datosanexos"
                            aria-controls="DatosMaestrosAnexos"
                            aria-selected="false">
                            Anexos
                        </a> */}
                    </div>
                </nav>
                <div className="tab-content border border-top-0 rounded-bottom pt-3">
                    <div
                        id="DatosMaestrosGeneral"
                        className="container tab-pane active" >
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                {/* Teléfono 1 */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtTel1"> Teléfono 1 </label>
                                    </div>
                                    <input
                                        id="txtTel1"
                                        className="form-control"
                                        disabled={((action === 2 && !editMode)) || disableField}
                                        value={partnerModel.Phone1 ? partnerModel.Phone1 : ""}
                                        onChange={this.changeBusinessPartnerPhone1}
                                    />
                                </div>

                                {/* Teléfono 2 */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <label className="input-group-text font-weight-bold" htmlFor="txtTel1"> Teléfono 2 </label>
                                    </div>
                                    <input
                                        id="txtTel1"
                                        className="form-control"
                                        disabled={(action === 2 && !editMode) || disableField}
                                        value={partnerModel.Phone2 ? partnerModel.Phone2 : ""}
                                        onChange={this.changeBusinessPartnerPhone2} />
                                </div>

                                {/* Activo */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <input
                                                id="rbActive"
                                                type="radio"
                                                disabled={(action === 2 && !editMode) || disableField}
                                                checked={partnerModel.validFor === 'Y'}
                                                onChange={() => this.changePartnerActive('Y')} />
                                        </span>
                                    </div>
                                    <label className="form-control" htmlFor="rbActive"> Activo </label>
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">
                                            <input
                                                id="rbInactive"
                                                type="radio"
                                                disabled={(action === 2 && !editMode) || disableField}
                                                checked={partnerModel.validFor === 'N'}
                                                onChange={() => this.changePartnerActive('N')} />
                                        </span>
                                    </div>
                                    <label className="form-control" htmlFor="rbInactive"> Inactivo </label>
                                </div>
                            </div>



                            <div className="col-12 col-lg-6">
                                {this.props.auxView === 'referredPartner' &&
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold"> Embajador </span>
                                        </div>
                                        <input
                                            className="form-control"
                                            disabled
                                            value={partnerModel.U_FMB_RELATED_AMBASSADOR === '' ? 'SIN ASIGNAR' : partnerModel.U_FMB_RELATED_AMBASSADOR} />

                                        {(action === 1 || (action === 2 && editMode)) &&
                                            <div className="input-group-prepend">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-warning rounded-right"
                                                    disabled={(action === 2 && !editMode)}
                                                    onClick={this.OpenModalPartner} >
                                                    <i className="fa fa-list" />
                                                </button>
                                            </div>
                                        }
                                    </div>

                                }


                                {/*EMPLEADO DE VENTAS*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Empleado Ventas </span>
                                    </div>
                                    <input
                                        className="form-control"
                                        disabled
                                        value={partnerModel.SlpName ? partnerModel.SlpName : ""} />

                                    {(action === 1 || (action === 2 && editMode)) &&
                                        <div className="input-group-prepend">
                                            <button
                                                type="button"
                                                className="btn btn-outline-warning rounded-right"
                                                disabled={(action === 2 && !editMode) || disableField}
                                                onClick={this.openEmployee} >
                                                <i className="fa fa-list" />
                                            </button>
                                        </div>
                                    }
                                </div>

                                {/*TERRITORIO*/}
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Territorio </span>
                                    </div>
                                        <input
                                            id="txtTel2"
                                            className="form-control"
                                            disabled
                                            value={partnerModel?.TerritoryName || ""}/>
                                    {(action === 1 || (action === 2 && editMode)) &&
                                        <div className="input-group-prepend">
                                            <button
                                                type="button"
                                                className="btn btn-outline-warning rounded-right"
                                                disabled={(action === 2 && !editMode)}
                                                onClick={this.openTerritory} >
                                                <i className="fa fa-list" />
                                            </button>
                                        </div>
                                    }
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div // Condiciones de Pago
                        id="DatosMaestrosCondPago"
                        className="container tab-pane fade"
                        role="datoscondpago"
                        aria-labelledby="nav-profile-tab-CondPago" >
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                {/* Condicion de pago */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Cond. de Pago </span>
                                    </div>
                                    <input
                                        id="txtGroupNumName"
                                        type="text"
                                        className="form-control"
                                        disabled
                                        value={partnerModel?.GroupNumName || ''} />
                                    {(action === 1) &&
                                        <div className="input-group-prepend">
                                            <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openGroupNum}>
                                                <i className="fa fa-list" />
                                            </button>
                                        </div>
                                    }
                                </div>

                                {/* Limite de credito */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Límite crédito </span>
                                    </div>
                                    <input
                                        id="txtCreditLine"
                                        className="form-control text-right"
                                        disabled={action === 2}
                                        onChange={this.changeCreditLine}
                                        onBlur={this.validateCreditLineNull}
                                        value={partnerModel?.CreditLine || ""} />
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold rounded-right"> {CURRENCY} </span>
                                    </div>
                                </div>

                                {/* Limite comprometido */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Límite compra </span>
                                    </div>
                                    <input
                                        id="txtDebitLine"
                                        className="form-control text-right"
                                        disabled={action === 2}
                                        onChange={this.changeDebitLine}
                                        onBlur={this.validateDebitLineNull}
                                        value={partnerModel.DebtLine} />
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold rounded-right"> {CURRENCY} </span>
                                    </div>
                                </div>

                                {/* Lista de precios */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Lista de Precios </span>
                                    </div>
                                    <input
                                        id="txtPriceListNumName"
                                        className="form-control"
                                        disabled
                                        value={partnerModel?.PriceListNumName || ''} />
                                    {(action === 1 || (action === 2 && editMode)) &&
                                        <div className="input-group-prepend">
                                            <button type="button" className="btn btn-outline-warning rounded-right" disabled={disableField} onClick={this.openListNum}>
                                                <i className="fa fa-list" />
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-lg-6">
                                {/* País del banco */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> País del banco </span>
                                    </div>
                                    <input
                                        id="txtBankCountr"
                                        className="form-control"
                                        disabled
                                        value={partnerModel?.BankCountr || ""} />
                                    {(action === 1 || (action === 2 && editMode)) &&
                                        <div className="input-group-prepend">
                                            <button type="button" className="btn btn-outline-warning rounded-right" disabled={disableField} onClick={() => this.openBankAccount('invoices')}>
                                                <i className="fa fa-list" />
                                            </button>
                                        </div>
                                    }
                                </div>

                                {/* Nombre del banco */}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Nombre del banco </span>
                                    </div>
                                    <input
                                        id="txtBankCode"
                                        className="form-control"
                                        disabled
                                        value={partnerModel.BankCode || ""} />
                                </div>

                                {/*Código bancario*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Código bancario </span>
                                    </div>
                                    <input
                                        id="txtDefaultBankCode"
                                        className="form-control"
                                        disabled
                                        value={partnerModel.DefaultBankCode || ""} />
                                </div>

                                {/*Cuenta*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Cuenta </span>
                                    </div>
                                    <input
                                        id="txtDflAccount"
                                        className="form-control"
                                        disabled
                                        value={partnerModel.DflAccount || ""} />
                                </div>

                                {/*Código BIC/SWIFT*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Código BIC/SWIFT </span>
                                    </div>
                                    <input
                                        id="txtDflSwift"
                                        className="form-control"
                                        disabled
                                        value={partnerModel.DflSwift || ""} />
                                </div>

                                {/*Sucursal*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Sucursal </span>
                                    </div>
                                    <input
                                        id="txtDflBranch"
                                        className="form-control"
                                        disabled
                                        value={partnerModel.DflBranch || ""} />
                                </div>

                                {/*ID int.ctrl.*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> ID int.ctrl. </span>
                                    </div>
                                    <input
                                        id="txtBankCtlKey"
                                        className="form-control"
                                        disabled
                                        value={partnerModel.BankCtlKey || ""} />
                                </div>

                                {/*IBAN*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> IBAN </span>
                                    </div>
                                    <input
                                        id="txtDflIBAN"
                                        className="form-control"
                                        disabled
                                        value={partnerModel.DflIBAN || ""} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div // Direcciones
                        className="container tab-pane fade"
                        id="DatosMaestrosDirecciones"
                        role="datosdirecciones"
                        aria-labelledby="nav-profile-tab-Direcciones" >
                        <div>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary active"
                                        id="nav-profile-tab-dirFacturacion"
                                        data-toggle="tab"
                                        href="#dirfactura"
                                        role="direccionfactura"
                                        aria-controls="dirfactura"
                                        aria-selected="true">
                                        Dirección de Facturación
                                    </a>
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary "
                                        id="nav-profile-tab-dirEntregas"
                                        data-toggle="tab"
                                        href="#direntrega"
                                        role="direccionentrega"
                                        aria-controls="direntrega"
                                        aria-selected="false">
                                        Dirección de Entrega
                                    </a>
                                </div>
                            </nav>
                            <div className="tab-content border border-top-0 rounded-bottom pt-3 mb-3">
                                <div className="container tab-pane fade show active"
                                    id="dirfactura"
                                    role="direccionfactura"
                                    aria-labelledby="nav-profile-tab-dirFacturacion" >
                                    <div className="row col-sm col">
                                        <div className="col-12 col-lg-6">
                                            {/*Facturacion*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Dir. Factura </span>
                                                </div>
                                                <input
                                                    id="txtBillAddress"
                                                    className="form-control"
                                                    disabled
                                                    value={invoicesAddress?.Address || ""} />
                                                <div className="input-group-prepend">
                                                    {(action === 1 || (action === 2 && editMode)) && (
                                                        <button type="button" className="btn btn-outline-success" onClick={() => this.addAddresses('invoices')}>
                                                            <i className="fa fa-plus" />
                                                        </button>
                                                    )}
                                                    <button type="button" className="btn btn-outline-warning rounded-right" onClick={() => this.openAddresses('invoices')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                </div>
                                            </div>

                                            {/*invoices*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Facturación estándar </span>
                                                </div>
                                                <input
                                                    id="txtBillToDef"
                                                    className="form-control"
                                                    disabled
                                                    value={partnerModel?.BillToDef || ""} />
                                            </div>
                                        </div>

                                        {/*segunda columna*/}
                                        <div className="col-12 col-lg-6">
                                            {/*ID direccion*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> ID Dirección </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress?.Address || ""}
                                                    onChange={(event) => this.changeAddress(event, 'invoices')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*Street*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Calle/Número </span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress?.Street || ""}
                                                    onChange={(event) => this.changeStreet(event, 'invoices')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*Block*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Colonia </span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress?.Block || ""}
                                                    onChange={(event) => this.changeBlock(event, 'invoices')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*City*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Ciudad </span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress?.City || ""}
                                                    onChange={(event) => this.changeCity(event, 'invoices')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*ZipCode*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Código Postal </span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress?.ZipCode || ""}
                                                    onChange={(event) => this.changeZipCode(event, 'invoices')}
                                                    onBlur={this.ValidateZipCodeBill} />
                                            </div>
                                            <div className="form-group formulario__grupo" id="grupo__BPIA6">
                                                <p className="form__input-error" style={{ marginTop: "-14px" }}> Son 5 numeros </p>
                                                <p className="form__input-void" style={{ marginTop: "-14px" }}> No puede ir vacío </p>
                                            </div>

                                            {/*County*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Condado</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress.County ? invoicesAddress.County : ""}
                                                    onChange={(event) => this.changeCounty(event, 'invoices')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*Pais*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">País</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled
                                                    value={invoicesAddress.Country ? invoicesAddress.Country : ""}
                                                    id="txtTel2" />
                                                {(action === 1 || (action === 2 && editMode)) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        disabled={(action === 2 && !editMode)}
                                                        onClick={() => this.openCountry('invoices')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>

                                            {/*State*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Estado</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled
                                                    value={invoicesAddress.State ? invoicesAddress.State : ""}
                                                    id="txtTel2" />
                                                {(action === 1 || (action === 2 && editMode)) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        disabled={(action === 2 && !editMode)}
                                                        onClick={() => this.openState('invoices')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>

                                            {/*TaxCode
                                            <div className="form-group row" id="div1">
                                                <label htmlFor="txtContactPerson"
                                                       className="col-md-4 col-sm-12 col-form-label font-weight-bold">Impuesto: </label>
                                                <div className="col-md-6 col-sm-12">
                                                    <input className="form-control"
                                                           style={{
                                                               backgroundColor: 'transparent',
                                                               borderColor: '#ced4da',
                                                               color: '#000'
                                                           }}
                                                           disabled={(action === 2 && !editMode)}
                                                           value={invoicesAddress.TaxCode ? invoicesAddress.TaxCode : ""}
                                                           onChange={(event) => this.changeTaxCode(event, 'invoices')}
                                                           id="txtTel2"/>
                                                </div>
                                            </div>*/}

                                            {/*StreetNo*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">No. Calle</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress.StreetNo ? invoicesAddress.StreetNo : ""}
                                                    onChange={(event) => this.changeStreetNo(event, 'invoices')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*Building*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Edificio/Planta/Sale</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress.Building ? invoicesAddress.Building : ""}
                                                    onChange={(event) => this.changeBuilding(event, 'invoices')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*GlblLocNum*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">GLN</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={invoicesAddress.GlblLocNum ? invoicesAddress.GlblLocNum : ""}
                                                    onChange={(event) => this.changeGlblLocNum(event, 'invoices')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*fijar como estandar*/}
                                            <div className="form-group row div1">
                                                <label htmlFor="txtContactPerson"
                                                    className="col-md-4 col-sm-12 col-form-label font-weight-bold">Fijar
                                                    como
                                                    estándar: </label>
                                                <div className="col-md-6 col-sm-12">
                                                    {(action === 1 || (action === 2 && editMode)) && (
                                                        <button
                                                            type="button"
                                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                            className="btn"
                                                            onClick={() => this.changeAddressDefault('invoices')}>
                                                            <i className="fas fa-check" />
                                                        </button>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="container tab-pane fade"
                                    id="direntrega"
                                    role="direccionentrega"
                                    aria-labelledby="nav-profile-tab-dirEntregas" >

                                    <div className="row">
                                        <div className="col-12 col-lg-6">
                                            {/*Entrega*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Dir. Entrega</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled
                                                    value={deliveriesAddress.Address ? deliveriesAddress.Address : ""}
                                                    id="txtTel2" />
                                                <div className="input-group-prepend">
                                                    {(action === 1 || (action === 2 && editMode)) && (
                                                        <button type="button" className="btn btn-outline-success" onClick={() => this.addAddresses('deliveries')}>
                                                            <i className="fa fa-plus" />
                                                        </button>
                                                    )}
                                                    <button type="button" className="btn btn-outline-warning rounded-right" onClick={() => this.openAddresses('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                </div>
                                            </div>

                                            {/*Entrega*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Entrega estándar</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled
                                                    value={partnerModel.ShipToDef ? partnerModel.ShipToDef : ""}
                                                    id="txtTel2" />
                                            </div>
                                        </div>

                                        {/*segunda columna*/}
                                        <div className="col-12 col-lg-6">
                                            {/*ID direccion*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">ID Dirección</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.Address ? deliveriesAddress.Address : ""}
                                                    onChange={(event) => this.changeAddress(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*Street*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Calle/Número</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.Street ? deliveriesAddress.Street : ""}
                                                    onChange={(event) => this.changeStreet(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*Block*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Colonia</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.Block ? deliveriesAddress.Block : ""}
                                                    onChange={(event) => this.changeBlock(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*City*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Ciudad</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.City ? deliveriesAddress.City : ""}
                                                    onChange={(event) => this.changeCity(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*ZipCode*/}
                                            <div className="input-group mb-3 formulario__grupo">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Código Postal</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.ZipCode ? deliveriesAddress.ZipCode : ""}
                                                    onChange={(event) => this.changeZipCode(event, 'deliveries')}
                                                    onBlur={this.ValidateZipCodeShip} />
                                            </div>
                                            <div className="form-group formulario__grupo" id="grupo__BDA6">
                                                <p className="form__input-error" style={{ marginTop: "-14px" }}>{"Son 5 numeros"}</p>
                                                <p className="form__input-void" style={{ marginTop: "-14px" }}>No puede ir vacio.</p>
                                            </div>

                                            {/*County*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Condado</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.County ? deliveriesAddress.County : ""}
                                                    onChange={(event) => this.changeCounty(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*Country*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">País</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled
                                                    value={deliveriesAddress.Country ? deliveriesAddress.Country : ""}
                                                    id="txtTel2" />
                                                {(action === 1 || (action === 2 && editMode)) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        disabled={(action === 2 && !editMode)}
                                                        onClick={() => this.openCountry('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>

                                            {/*State*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Estado</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled
                                                    value={deliveriesAddress.State ? deliveriesAddress.State : ""}
                                                    id="txtTel2" />
                                                {(action === 1 || (action === 2 && editMode)) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        disabled={(action === 2 && !editMode)}
                                                        onClick={() => this.openState('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>

                                            {/*TaxCode*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Impuesto</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.TaxCode ? deliveriesAddress.TaxCode : ""}
                                                    id="txtTel2" />
                                                {(action === 1 || (action === 2 && editMode)) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        disabled={(action === 2 && !editMode)}
                                                        onClick={() => this.openTaxes('deliveries')}>
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>

                                            {/*StreetNo*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">No. Calle</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.StreetNo ? deliveriesAddress.StreetNo : ""}
                                                    onChange={(event) => this.changeStreetNo(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*Building*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Edificio/Planta/Sale</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress.Building ? deliveriesAddress.Building : ""}
                                                    onChange={(event) => this.changeBuilding(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>

                                            {/* TaxOffice */}
                                            {/* <div className="form-group row" id="div1">
                                                <label htmlFor="txtContactPerson"
                                                       className="col-md-4 col-sm-12 col-form-label font-weight-bold">Hacienda: </label>
                                                <div className="col-md-6 col-sm-12">
                                                    <input className="form-control"
                                                           style={{
                                                               backgroundColor: 'transparent',
                                                               borderColor: '#ced4da',
                                                               color: '#000'
                                                           }}
                                                           disabled={(action === 2 && !editMode)}
                                                           value={deliveriesAddress.TaxOffice ? deliveriesAddress.TaxOffice : ""}
                                                           onChange={(event) => this.changeTaxOffice(event, 'deliveries')}
                                                           id="txtTel2"/>
                                                </div>
                                            </div> */}

                                            {/*GlblLocNum*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">GLN</span>
                                                </div>
                                                <input className="form-control"
                                                    disabled={(action === 2 && !editMode)}
                                                    value={deliveriesAddress?.GlblLocNum || ""}
                                                    onChange={(event) => this.changeGlblLocNum(event, 'deliveries')}
                                                    id="txtTel2" />
                                            </div>

                                            {/*fijar como estandar*/}
                                            <div className="form-group row div1">
                                                <label htmlFor="txtContactPerson"
                                                    className="col-md-4 col-sm-12 col-form-label font-weight-bold">Fijar
                                                    como
                                                    estándar: </label>
                                                <div className="col-md-6 col-sm-12">
                                                    {(action === 1 || (action === 2 && editMode)) && (
                                                        <button
                                                            type="button"
                                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                            className="btn"
                                                            onClick={() => this.changeAddressDefault('deliveries')}>
                                                            <i className="fas fa-check" />
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div // Persona de contacto
                        id="DatosMaestrosContactPerson"
                        className="container tab-pane fade"
                        role="datoscontactperson"
                        aria-labelledby="nav-profile-tab-ContactPerson" >
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                {/*ID contacto*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Contacto</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        disabled
                                        value={contactPerson.Name ? contactPerson.Name : ""}
                                        id="inputBPCP0" />

                                    <div className="input-group-prepend">
                                        {(action === 1 || (action === 2 && editMode)) && (
                                            <button
                                                type="button"
                                                className="btn btn-outline-success"
                                                disabled={(action === 2 && !editMode)}
                                                onClick={this.addContactPersons}>
                                                <i className="fa fa-plus" />
                                            </button>
                                        )}
                                        <button
                                            type="button"
                                            className="btn btn-outline-warning rounded-right"
                                            onClick={this.openContactPersons}>
                                            <i className="fa fa-list" />
                                        </button>
                                    </div>
                                </div>

                                {/*estandar*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Contacto estándar</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        /*style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}*/
                                        style={{ backgroundColor: "#e9ecef", opacity: "1" }}
                                        value={partnerModel.CntctPrsn ? partnerModel.CntctPrsn : ""}
                                        id="txtTel2" disabled />
                                </div>
                            </div>

                            {/*Segunda columna*/}
                            <div className="col-12 col-lg-6">
                                {/*ID contacto*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">ID Contacto</span>
                                    </div>
                                    <input type=" text"
                                        className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Name ? contactPerson.Name : ""}
                                        onChange={this.changeIDContacto}
                                        id="txtTel2" />
                                    {/*(action === 1 || (action === 2 && editMode)) && (
                                        <button
                                            type="button"
                                            style={{backgroundColor: 'transparent', color: 'red'}}
                                            className="btn"
                                            disabled={(action === 2 && !editMode)}
                                            onClick={()  => this.deleteContactPersons(contactPerson.Name)}>
                                            <i className="fa fa-minus" aria-hidden="true"></i>
                                        </button>
                                    )*/}
                                </div>

                                {/*changeFirstName*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Nombre</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.FirstName ? contactPerson.FirstName : ""}
                                        onChange={this.changeFirstName}
                                        id="txtTel2" />
                                </div>

                                {/*Título*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Título</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Title ? contactPerson.Title : ""}
                                        onChange={this.changeTitle}
                                        id="txtTel2" />
                                </div>

                                {/*ID contacto*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Segundo Nombre</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.MiddleName ? contactPerson.MiddleName : ""}
                                        onChange={this.changeMiddleName}
                                        id="txtTel2" />
                                </div>

                                {/*Position*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Posición</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Position ? contactPerson.Position : ""}
                                        onChange={this.changePosition}
                                        id="txtTel2" />
                                </div>

                                {/*LastName*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Apellido</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.LastName ? contactPerson.LastName : ""}
                                        onChange={this.changeLastName}
                                        id="txtTel2" />
                                </div>

                                {/*Tel1*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Teléfono 1</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Tel1 ? contactPerson.Tel1 : ""}
                                        onChange={this.changeTel1}
                                        id="txtTel2" />
                                </div>

                                {/*Tel2*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Teléfono 2</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Tel2 ? contactPerson.Tel2 : ""}
                                        onChange={this.changeTel2}
                                        id="txtTel2" />
                                </div>

                                {/*Celular*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Celular</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Cellolar ? contactPerson.Cellolar : ""}
                                        onChange={this.changeCellolar}
                                        id="txtTel2" />
                                </div>

                                {/*Fax*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Fax</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Fax ? contactPerson.Fax : ""}
                                        onChange={this.changeFax}
                                        id="txtTel2" />
                                </div>

                                {/*E_mail*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Email</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""} value={contactPerson.E_MailL ? contactPerson.E_MailL : ""}
                                        onChange={this.changeE_mail}
                                        id="txtTel2" />
                                </div>

                                {/*Notes1*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Observaciones 1</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Notes1 ? contactPerson.Notes1 : ""}
                                        onChange={this.changeNotes1}
                                        id="txtTel2" />
                                </div>

                                {/*Notes2*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold">Observaciones 2</span>
                                    </div>
                                    <input className="form-control"
                                        style={{
                                            backgroundColor: 'transparent',
                                            borderColor: '#ced4da',
                                            color: '#000'
                                        }}
                                        // disabled={(action === 2 && !editMode)}
                                        onKeyDown={((action === 2 && !editMode)) ? (event) => event.preventDefault() : ""}
                                        value={contactPerson.Notes2 ? contactPerson.Notes2 : ""}
                                        onChange={this.changeNotes2}
                                        id="txtTel2" />
                                </div>

                                {/*Active*/}
                                <div className="form-group row div1">
                                    <label htmlFor="txtContactPerson"
                                        className="col-md-4 col-sm-12 col-form-label font-weight-bold">Activo: <input
                                            type="checkbox"
                                            disabled={(action === 2 && !editMode)}
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000'
                                            }}
                                            id="cbox1"
                                            checked={contactPerson.Active == 'Y' ? true : false}
                                            onChange={this.changeActiveContact} />
                                    </label>
                                    <div className="col-md-6 col-sm-12">

                                    </div>
                                </div>

                                {/*fijar como estandar*/}
                                <div className="form-group row div1">
                                    <label htmlFor="txtContactPerson"
                                        className="col-md-4 col-sm-12 col-form-label font-weight-bold">Fijar como
                                        estándar: </label>
                                    <div className="col-md-6 col-sm-12">
                                        {(action === 1 || (action === 2 && editMode)) && (
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                className="btn"
                                                onClick={this.changeContactDefault}>
                                                <i className="fas fa-check" />
                                            </button>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div // Finanzas
                        id="DatosMaestrosFinanzas"
                        className="container tab-pane fade"
                        role="datosfinanzas"
                        aria-labelledby="nav-profile-tab-Direcciones" >
                        <div>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary active"
                                        id="nav-profile-tab-confgeneral"
                                        data-toggle="tab"
                                        href="#confgeneral"
                                        role="confgeneral"
                                        aria-controls="confgeneral"
                                        aria-selected="true">
                                        General
                                    </a>
                                    <a
                                        className="nav-item nav-link font-weight-bold text-secondary "
                                        id="nav-profile-tab-confimpuesto"
                                        data-toggle="tab"
                                        href="#confimpuesto"
                                        role="confimpuesto"
                                        aria-controls="confimpuesto"
                                        aria-selected="false">
                                        Impuesto
                                    </a>
                                </div>
                            </nav>
                            <div className="tab-content border border-top-0 rounded-bottom pt-3 mb-3">
                                <div
                                    id="confgeneral"
                                    className="container tab-pane fade show active"
                                    role="confgeneral"
                                    aria-labelledby="nav-profile-tab-confgeneral" >
                                    <div className="row">
                                        <div className="col-12">
                                            {/* Consolidación */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <input
                                                            id="rbPayment"
                                                            type="radio"
                                                            value="P"
                                                            disabled={(action === 2 && !editMode) || disableField}
                                                            checked={partnerModel.FatherType === "P"}
                                                            onChange={(event) => this.onChangeValueConsolidacion2(event)} />
                                                    </span>
                                                </div>
                                                <label className="form-control" htmlFor="rbPayment"> Consolidación de pagos </label>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <input
                                                            id="rbDelivery"
                                                            type="radio"
                                                            value="D"
                                                            disabled={(action === 2 && !editMode) || disableField}
                                                            checked={partnerModel.FatherType === "D"}
                                                            onChange={(event) => this.onChangeValueConsolidacion2(event)} />
                                                    </span>
                                                </div>
                                                <label className="form-control" htmlFor="rbDelivery"> Consolidación de entregas </label>
                                            </div>

                                            {/*SN de Consolidación*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-Consolidacion">Proveedores</span>
                                                </div>
                                                <input
                                                    id="txtTel2"
                                                    className="form-control"
                                                    disabled
                                                    value={`${partnerModel?.DebPayAcct || ""} - ${partnerModel?.DebPayAcctName || ""}`} />
                                                {(action === 1 || (action === 2 && editMode)) &&
                                                    <div className="input-group-prepend">
                                                        <button type="button" className="btn btn-outline-warning rounded-right" disabled={disableField} onClick={() => this.openCuentaMayor(1)}>
                                                            <i className="fa fa-list" />
                                                        </button>
                                                    </div>
                                                }
                                            </div>

                                            {/* CUENTA COMPENSACION DE ANTICIPO */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Compensación de anticipo</span>
                                                </div>
                                                <select
                                                    id="selectProject"
                                                    className="form-control"
                                                    disabled={(action === 2 && !editMode) || disableField}
                                                    value={partnerModel.DownPaymentClearAct || ""}
                                                    onChange={(event) => this.ChangeDpmClear(event.target.value)} >
                                                    <option value="---"> Seleccionar </option>
                                                    {MajorAccounts && MajorAccounts.map(acct => {
                                                        return (
                                                            <option value={acct.AcctCode}>{acct.AcctCode} .- {acct.AcctName}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                            {/* CUENTA PROVISIONAL DE ANTICIPO */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">Provisional de anticipo</span>
                                                </div>
                                                <select
                                                    id="selectProject"
                                                    className="form-control"
                                                    disabled={(action === 2 && !editMode) || disableField}
                                                    value={partnerModel.DownPaymentInterimAccount || ""}
                                                    onChange={(event) => this.ChangeDpmIntAct(event.target.value)} >
                                                    <option value="---"> Seleccionar </option>
                                                    {MajorAccounts && MajorAccounts.map(acct => {
                                                        return (
                                                            <option value={acct.AcctCode}>{acct.AcctCode} .- {acct.AcctName}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>

                                            {/*SN de Consolidación*/}
                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-Consolidación">Cuenta de compensacón de artículos</span>
                                                </div>
                                                <input className="form-control"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000'
                                                        }}
                                                        disabled
                                                        value={invoicesAddress.Address ? invoicesAddress.Address : ""}
                                                        id="txtTel2"/>
                                                <button
                                                    type="button"
                                                    style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                                    className="input-group-text"
                                                    onClick={() => this.openAddresses('invoices')}>
                                                    <i className="fa fa-list" aria-hidden="true"/>
                                                </button>
                                                {(
                                                <label> Lusi David Rocha Zeron</label>
                                                )}
                                            </div> */}
                                            {/*SN de Consolidación*/}
                                            {/* <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-Consolidacion">Cuenta provisional de anticipos</span>
                                                </div>
                                                <input className="form-control"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderColor: '#ced4da',
                                                            color: '#000'
                                                        }}
                                                        disabled
                                                        value={invoicesAddress.Address ? invoicesAddress.Address : ""}
                                                        id="txtTel2"/>
                                                <button
                                                    type="button"
                                                    style={{backgroundColor: 'transparent', color: '#EABF28'}}
                                                    className="input-group-text"
                                                    onClick={() => this.openAddresses('invoices')}>
                                                    <i className="fa fa-list" aria-hidden="true"/>
                                                </button>
                                                {(
                                                <label> Lusi David Rocha Zeron</label>
                                                )}
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    id="confimpuesto"
                                    className="container tab-pane fade"
                                    role="confimpuesto"
                                    aria-labelledby="nav-profile-tab-confimpuesto" >
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/*Consolidación*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <input
                                                            id="rbVatStatusY"
                                                            type="radio"
                                                            value="Y"
                                                            disabled={(action === 2 && !editMode) || disableField}
                                                            checked={partnerModel.VatStatus === "Y"}
                                                            onChange={(event) => this.onChangeValueConsolidacion(event)} />
                                                    </span>
                                                </div>
                                                <label className="form-control" htmlFor="rbVatStatusY"> Obligatorio </label>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold">
                                                        <input
                                                            id="rbVatStatusN"
                                                            type="radio"
                                                            value="N"
                                                            disabled={(action === 2 && !editMode) || disableField}
                                                            checked={partnerModel.VatStatus === "N"}
                                                            onChange={(event) => this.onChangeValueConsolidacion(event)} />
                                                    </span>
                                                </div>
                                                <label className="form-control" htmlFor="rbVatStatusN"> Extranjeros </label>
                                            </div>

                                            {/*SN de Consolidación*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-Consolidacion"> Indicador de impuestos </span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    disabled
                                                    value={`${partnerModel?.TaxCode || ""} - ${partnerModel?.TaxName || ""}`}
                                                    id="txtTel21" />
                                                {(action === 1 || (action === 2 && editMode)) &&
                                                    <div className="input-group-prepend">
                                                        <button type="button" className="btn btn-outline-warning rounded-right" disabled={disableField} onClick={() => this.openTaxes('deliveries')}>
                                                            <i className="fa fa-list" />
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div // Propiedades
                        id="DatosMaestrosPropiedades"
                        className="container tab-pane fade"
                        role="datospropiedades"
                        aria-labelledby="nav-profile-tab-Propiedades" >
                        <table
                            id="DatosMaestrosPropiedades"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -2000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td style={{ backgroundColor: '#d2ab24', width: 200 }}>
                                        #
                                    </td>
                                    <td style={{ maxWidth: 500, backgroundColor: '#d2ab24' }}>
                                        Nombre de la Propiedad
                                    </td>
                                    <td style={{ backgroundColor: '#d2ab24', width: 100 }}>
                                        <input type="checkbox"></input>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ maxHeight: 10, paddingTop: 8, paddingBottom: 8 }}>
                                    {/*#*/}
                                    <td>
                                        <input
                                            type=" text"
                                            className=" form-control"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                maxWidth: '100%',
                                                textAlign: "center",
                                            }} />
                                    </td>
                                    {/*codigo*/}
                                    <td style={{ textAlign: 'center' }}>
                                        <input
                                            type=" text"
                                            className=" form-control"
                                            style={{
                                                backgroundColor: 'transparent',
                                                borderColor: '#ced4da',
                                                color: '#000',
                                                paddingTop: 1,
                                                paddingBottom: 2,
                                                maxWidth: '100%',
                                                textAlign: "center",
                                            }}
                                        />
                                    </td>
                                    {/*check*/}
                                    <td style={{ textAlign: "center" }}>
                                        <input type="checkbox"></input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div // Ejecucion de Pago
                        id="DatosMaestrosEjecPago"
                        className="container tab-pane fade"
                        role="datosejecpago"
                        aria-labelledby="nav-profile-tab-EjecPago" >
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                {/*limite de credito*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Info. de referencia </span>
                                    </div>
                                    <input
                                        id="txtTel1"
                                        className="form-control"
                                        disabled={(action === 2 && !editMode)}
                                        onChange={this.changeRefDetails}
                                        value={partnerModel.RefDetails} />
                                </div>

                                {/*metodo Pago*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold"> Método de pago </span>
                                    </div>
                                    <input
                                        id="txtTel1"
                                        className="form-control"
                                        disabled
                                        value={partnerModel?.PymCodeName || ''} />
                                    {(action === 1 || (action === 2 && editMode)) &&
                                        <div className="input-group-prepend">
                                            <button type="button" className="btn btn-outline-warning rounded-right" onClick={this.openPayMethod}>
                                                <i className="fa fa-list" />
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderBussinesFooter = () => {
        return (
            <div className="row">

                <div className="col-12 col-md-6">
                    {/*Teléfono1*/}
                    <div className="form-group row" id="div1">
                        <label htmlFor="txtContactPerson"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">Condición de
                            Pago: </label>
                        <div className="col-md-6 col-sm-12">
                            <select id="inputState" className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                <option selected>...</option>
                                <option>...</option>
                            </select>
                        </div>

                    </div>
                    {/*Teléfono2*/}
                    <div className="form-group row" id="div1">
                        <label htmlFor="txtContactPerson"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">Método de Pago</label>
                        <div className="col-md-6 col-sm-12">
                            <select id="inputState" className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                <option selected>...</option>
                                <option>...</option>
                            </select>
                        </div>

                    </div>
                </div>
                {/*Segunda columna*/}
                <div className="col-sm" style={{ paddingRight: 0 }}>
                    {/*Moneda Local*/}
                    <div className="form-group row" id="div1">
                        <label htmlFor="txtContactPerson"
                            className="col-md-4 col-sm-12 col-form-label font-weight-bold">Lista de Precios: </label>
                        <div className="col-md-6 col-sm-12">
                            <select id="inputState" className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}>
                                <option selected>...</option>
                                <option>...</option>
                            </select>
                        </div>
                    </div>
                    {/*RFC DE SOCIO DE NEGOCIOS*/}
                    <div className="form-group row " id="div1">
                        <label htmlFor="txtAlmacen" className="col-md-4 col-sm-12 col-form-label font-weight-bold">Límite
                            de Crédito:</label>
                        <div className="col-md-6 col-sm-12">
                            <input type="text" className="form-control"
                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                id="txtRFC" />
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    openUserFields = () => {
        $('#userFieldsPartnerModal').modal('show');
    };

    renderSelector = () => {
        return (
            <div className="row">
                <div className="form-group row navigation-tabs2 text-right" style={{ paddingRight: 73 }}>
                    <label htmlFor="txtCustomer" className="col col-form-label col-form-label-md text-right font-weight-bold">
                        <span className="d-none d-xl-inline">Campos de Usuario</span>
                        <span className="d-inline d-xl-none">Campos Usuario</span>
                    </label>
                    <button
                        type="button"
                        style={{
                            backgroundColor: 'transparent',
                            color: '#EABF28',
                        }}
                        className="btn "
                        onClick={this.openUserFields}>
                        <i className="fa fa-list" />
                    </button>
                </div>
                <br></br><br></br>
            </div>
        );
    };

    refreshPartner = async (partner, totalPage) => {
        this.setState({
            partners: partner,
            pageTotal: totalPage
        });
    }

    SearchPartnerCloseAct = async () => {
        await this.setState({
            enableSearchPartner: false
        });
    }

    OnChangeRelatedAmbassador = (value) => {
        const { partnerModel, refreshModel } = this.props;
        partnerModel.U_FMB_RELATED_AMBASSADOR = value;
        refreshModel(partnerModel);
    }


    ReceiveInfoByInfo = async (info) => {
        this.OnChangeRelatedAmbassador(info.CardCode ?? '')
        $('#searchPartnerRefSys').modal('hide');
        await this.setState({
            enableSearchPartner: false
        });
    }

    render() {
        const { action, partnerModel, view, showAlert, enableSpinner, refreshModel } = this.props;
        const { editMode, groupCodes, cardTypes, currencies,
            employees, groupNums, prices, territories, contactPersons,
            addresses, countries, states, taxes, payMethods,
            CardCodeBalance,
            AccountBalan,
            AccountBalanceData,
            cardCodeReferenceList,
            accounts } = this.state;

        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="BussinesPartner"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">

                {this.state.enableSearchPartner &&
                    <SearchPartnerRefSys
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        actionLabel={"Seleccionar embajador"}
                        typeSearch={"SearchAmbassadors"}
                        closeAction={this.SearchPartnerCloseAct}
                        ReceiveFather={this.ReceiveInfoByInfo}
                    />
                }

                <BankAccountModal
                    enableSpinner={enableSpinner}
                    showAlert={showAlert}
                    partnerModel={partnerModel}
                    refreshModel={refreshModel}
                    deleteBank={this.deleteBank}
                    selectBankDefault={this.selectBankDefault}
                    changeAccountBank={this.changeAccountBank}
                    changeControlKeyBank={this.changeControlKeyBank}
                    changeBranchBank={this.changeBranchBank}
                    changeIBANBank={this.changeIBANBank}
                    changeSwiftNumBank={this.changeSwiftNumBank}

                    cleanData={() => this.setState({ addresses: [] })}
                />
                <AccountBalancePartner
                    enableSpinner={enableSpinner}
                    showAlert={showAlert}
                    CardCodeBalance={CardCodeBalance}
                    AccountBalan={AccountBalan}
                    newOrderModel={partnerModel}
                    AccountBalanceData={AccountBalanceData}
                    openAccountBalance={this.openAccountBalance}
                />

                <UserFieldsPartnerModal
                    newOrderModel={partnerModel}
                    action={action}
                    refreshModel={this.refreshModel}
                    view={view}
                    editMode={editMode}
                />

                <PayMethodModal
                    data={payMethods}
                    selectpayMethod={this.selectPayMethod}
                    cleanData={() => this.setState({ payMethods: [] })}
                />

                <ImpuestoPartnerModal
                    data={taxes}
                    selectTaxe={this.selectTaxes}
                    cleanData={() => this.setState({ taxes: [] })}
                />

                <StatesModal
                    data={states}
                    selectCountry={this.selectState}
                    cleanData={() => this.setState({ states: [] })}
                />

                <CountryModal
                    data={countries}
                    selectCountry={this.selectCountry}
                    cleanData={() => this.setState({ countries: [] })}
                />

                <ContactPersonsPartnerModal
                    data={contactPersons}
                    selectContactPersons={this.selectContactPersons}
                    cleanData={() => this.setState({ contactPersons: [] })}
                />

                <AddressesPartnerModal
                    data={addresses}
                    selectAddresses={this.selectAddresses}
                    deleteAddresses={this.deleteAddresses}
                    cleanData={() => this.setState({ addresses: [] })}
                />

                <GroupCodeModal
                    data={groupCodes}
                    selectGroupCode={this.selectGroupCode}
                    cleanData={() => this.setState({ groupCodes: [] })}
                />

                <CardCodeReferenceCreationModal
                    data={cardCodeReferenceList}
                    cleanData={() => this.setState({ cardCodeReferenceList: [] })}
                />

                <TerritoriesModal
                    data={territories}
                    selectTerritories={this.selectTerritories}
                    cleanData={() => this.setState({ territories: [] })}
                />

                <CardTypeModal
                    data={cardTypes}
                    selectCardType={this.selectCardType}
                    cleanData={() => this.setState({ cardTypes: [] })}
                />

                <CurrencyModal
                    data={currencies}
                    selectCurrency={this.selectCurrency}
                    cleanData={() => this.setState({ currencies: [] })}
                />

                <EmployeeSalesPartnerModal
                    data={employees}
                    selectEmployee={this.selectEmployee}
                    cleanData={() => this.setState({ employees: [] })}
                />

                <GroupNumModal
                    data={groupNums}
                    selectGroupNum={this.selectGroupNum}
                    cleanData={() => this.setState({ groupNums: [] })}
                />

                <PriceListPartnerModal
                    data={prices}
                    selectPriceList={this.selectPriceList}
                    cleanData={() => this.setState({ prices: [] })}
                />
                <AccountListPartnerModal
                    data={accounts}
                    selectAccount={this.selectAccountList}
                    cleanData={() => this.setState({ accounts: [] })}
                />
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>

                            <h4 className="modal-title" id="modal-basic-title ">{`DATOS DEL ${this.props.auxView === 'referredPartner' ? ' CLIENTE REFERIDO' : 'EMBAJADOR'}`}</h4>

                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {/* renderSelector works fine not done yet but commented because the client dosent nedd at this moment */}
                            {/* {this.renderSelector()} */}
                            {this.renderEditButton()}
                            {this.renderBussinesHeader()}
                            {this.renderBussinesBody()}
                            {/* <h4><label htmlFor="txtName" className="font-weight-bold" style={{color: '#6c757d'}}>CONDICIONES DE
                                PAGO: </label> <br></br></h4>
                            {this.renderBussinesFooter()} */}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar
                            </button>
                            {action === 1 && <button type="button" className="btn botonCorrect text-black"
                                onClick={this.sendModel}> Crear</button>}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.ValidateAll(this.acceptEditMode)}>
                                    Guardar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                {this.openAction()}
            </div>
        );
    }
}

export default ReferralSystemPerson;